<div class="transport-status-editor" [formGroup]="detailsFormGroup">
    <div>
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.transport-status-editor.transport-status"></sc-dictionary-label>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusAny" name="transportStatusAny">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.transport-status-editor.transport-status.any"></sc-dictionary-label>
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusPlanned" name="transportStatusPlanned">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.transport-status-editor.transport-status.planned"></sc-dictionary-label>
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusRegistered"
            name="transportStatusRegistered">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.transport-status-editor.transport-status.registered"></sc-dictionary-label>
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusWaiting" name="transportStatusWaiting">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.transport-status-editor.transport-status.waiting"></sc-dictionary-label>
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusRetrieved" name="transportStatusRetrieved">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.transport-status-editor.transport-status.retrieved"></sc-dictionary-label>
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusLoadingCompleted" name="transportStatusLoadingCompleted">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.transport-status-editor.transport-status.loading-completed"></sc-dictionary-label>
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusCompleted" name="transportStatusCompleted">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.transport-status-editor.transport-status.completed"></sc-dictionary-label>
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusFinished" name="transportStatusFinished">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.transport-status-editor.transport-status.finished"></sc-dictionary-label>
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusCanceled" name="transportStatusCanceled">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.transport-status-editor.transport-status.canceled"></sc-dictionary-label>
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusPaused" name="transportStatusPaused">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.transport-status-editor.transport-status.paused"></sc-dictionary-label>
        </mat-checkbox>
    </div>
</div>
